// extracted by mini-css-extract-plugin
export default {"content":"style_content__Q-GAU","itemName":"style_itemName__twaoD","leftSide":"style_leftSide__olajg","rightSide":"style_rightSide__HmnXv","type":"style_type__Qi3Ix"};